module.exports = __webpack_public_path__ + "img/affiliation.b0476ad2.svg";